import { useState, useEffect } from 'react'
import { URLBACK } from '../../assets/urls'
import StandupSetting from '../../components/StandupSetting'
import { useAxiosWithHeader } from '../../utils'
import { useSelector } from 'react-redux'
import { Organization } from '../../reducers/organizationReducer'

export default function StandupPage() {
  const axios = useAxiosWithHeader()
  const organization = useSelector(Organization.selectors.getOrganization)
  const [engineer, setEngineer] = useState({})
  const [globalLoader, setGlobalLoader] = useState(true)

  useEffect(() => {
    if (!organization.id) return

    setGlobalLoader(true)
    axios
      .get(`${URLBACK}engineer/me/${organization.id}`)
      .then((engineerResp) => {
        setEngineer(engineerResp.data)
        setGlobalLoader(false)
      })
      .catch((error) => {
        console.log('error getting engineer info', error)
        setEngineer(error)
        setGlobalLoader(false)
      })
  }, [organization.id])
  // if (globalLoader) return 'bloop'
  return <StandupSetting engineer={engineer} globalLoader={globalLoader} isAdmin={true} />
}
